import { BaseService } from "services/_baseService";
import { ResponseTemplate } from "interfaces/entities/responseTemplate.model";

class ResponseTemplatesAdminService extends BaseService<ResponseTemplate> {
    constructor() {
        super(`response-templates`);
    }
}

export default new ResponseTemplatesAdminService();
